import { Button } from '@heroui/react';

import { ArrowLeftIcon } from '@radix-ui/react-icons';

import { CodeInput } from '@/features/auth/ui/code-input';

type CodeStepProps = {
  email: string;
  onSubmit: (code: string) => Promise<void>;
  onBack: () => void;
  onResend: () => Promise<void>;
  isVerifying: boolean;
  isCodeError: boolean;
  isResending: boolean;
  timeLeft: number;
  canResend: boolean;
};

export const CodeStep = ({
  onSubmit,
  onBack,
  onResend,
  isVerifying,
  isCodeError,
  isResending,
  timeLeft,
  canResend,
}: CodeStepProps) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 mb-2">
        <Button
          isIconOnly
          variant="ghost"
          size="sm"
          onPress={onBack}
          className="text-gray-600 hover:text-purple-600 hover:bg-purple-500/10"
        >
          <ArrowLeftIcon className="w-4 h-4" />
        </Button>
        <span className="text-sm text-gray-600">Back to email</span>
      </div>

      <CodeInput
        onComplete={onSubmit}
        disabled={isVerifying}
        error={isCodeError}
        onChange={() => {
          // Clear error when user starts typing new code
        }}
      />

      {isVerifying && (
        <div className="text-center">
          <p className="text-gray-600 text-sm">Verifying your code...</p>
        </div>
      )}

      <div className="text-center space-y-2">
        {!canResend ? (
          <p className="text-sm text-gray-600">
            You can request another code in{' '}
            <span className="text-purple-600 font-medium">{timeLeft}s</span>
          </p>
        ) : (
          <p className="text-sm text-gray-600">
            Didn't receive the code?{' '}
            <button
              type="button"
              onClick={onResend}
              disabled={isResending}
              className="text-purple-600 hover:text-purple-700 underline disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer font-medium"
            >
              {isResending ? 'Sending...' : 'Resend code'}
            </button>
          </p>
        )}
      </div>
    </div>
  );
};
